/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Raffle_Pool_No_Victory_PointInputs */



/**
* | output |
* | --- |
* | "No victory point" |
*
* @param {Raffle_Pool_No_Victory_PointInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const raffle_pool_no_victory_point = /** @type {((inputs?: Raffle_Pool_No_Victory_PointInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Raffle_Pool_No_Victory_PointInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sans point de victoire")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sin punto de victoria")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sem ponto de vitória")
	if (locale === "it") return /** @type {LocalizedString} */ ("Senza punto vittoria")
	return /** @type {LocalizedString} */ ("No victory point")
});